import html2canvas from "html2canvas";

export const captureScreen = async () => {
  return html2canvas(document.getElementById("root")).then((canvas) => {
    return canvas;
  });
};
